import { Box, SvgIcon, useTheme } from '@mui/material';
import { tokens } from '../theme';
import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2
import SearchBarFilter from './SearchBarFilter';

const SectionHeader = ({
    sectionHeading,
    sectionIcon,
    isSearchBarEnabled,
    filterProps,
    onSearch,
}) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    return (
        <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            pb={10}
            backgroundColor={'rgba(255,255,255,0.6)'}
            opacity={5}
            borderRadius={2}
            p={3}
            alignItems={'center'}
        >
            <Grid
                container
                direction={'row'}
                alignItems={'center'}
                justifyContent="space-between"
                spacing={2}
            >
                <Grid item>
                    <Grid
                        container
                        direction={'row'}
                        alignItems={'center'}
                        spacing={2}
                    >
                        <Grid item>
                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                            >
                                {/* <img src={sectionIcon} width={24} /> */}
                                <SvgIcon sx={{ width: '24px', height: 'auto' }}>
                                    {sectionIcon}
                                </SvgIcon>
                            </Box>
                        </Grid>
                        <Grid item fontSize={20} fontWeight={700}>
                            {sectionHeading}
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item>
                    {isSearchBarEnabled && (
                        <Grid item>
                            <SearchBarFilter
                                filterProps={filterProps}
                                onSearch={onSearch}
                            />
                        </Grid>
                    )}
                </Grid>
            </Grid>
        </Grid>
    );
};

export default SectionHeader;
